export const customRoutes = [
  // <Route exact path="/price-calculator" component={PriceCalculator} />,
  // <Route exact path="/lead-components" component={LeadComponents} />,
  // <Route exact path="/notifications" reference="lead-notifications" component={ListNotifications} />,
  // <Route exact path="/inbound-call" render={(props) => <CallPopping {...props} />} />,
]
